import {UPDATE_TEXTS, UPDATE_LAYOUT, UPDATE_DESIGN} from '../actions';

export default function chatSettings(state = {}, action) {
  switch (action.type) {
    case UPDATE_TEXTS: {
      const newTexts = Object.assign({}, state.texts, action.texts);
      return Object.assign({}, state, {texts: newTexts});
    }
    case UPDATE_LAYOUT: {
      const newLayout = Object.assign({}, state.layout, action.layout);
      return Object.assign({}, state, {layout: newLayout});
    }
    case UPDATE_DESIGN: {
      const newDesign = Object.assign({}, state.design, action.design);
      return Object.assign({}, state, {design: newDesign});
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./chat-app/reducers/chatSettings.js